import React from 'react'
import './MyTasks.css';
function MyTasks() {
  return (
    <div className='MyTasks'>
<div className='MyTasks__container'>
  <h1>Card</h1>
</div>
      </div>
  )
}

export default MyTasks